import { Image } from "antd";
import { FC } from "react";
import { TaskAddPhoto } from "tm-shared/types";

import { useAppSelector } from "@/hooks/redux";
import { getFileUrl } from "@/utils/file/getFileUrl";

import { TaskViewModal } from "../TaskViewModal";

interface AddPhotoViewModalProps {
    task: TaskAddPhoto;
    onClose: () => void;
}

export const AddPhotoViewModal: FC<AddPhotoViewModalProps> = ({
    task,
    onClose,
}) => {
    const { markets } = useAppSelector((s) => s.work);
    const completedAt = task?.completedAt;
    const currentMarket = markets[task.targetId];

    if (!currentMarket || !completedAt) return null;

    const photo = currentMarket.photo;

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Image
                alt={currentMarket.name}
                src={getFileUrl(photo)}
                height={"auto"}
                width={"100%"}
            />
        </TaskViewModal>
    );
};
